import React from 'react';
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getMissingPartsTools } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const MissingPartsToolsReport = () => {
  const { customCaptions, application } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();

  const chartConfig = {
    id: 'missing-parts-tools',
    title: `Missing ${
      application.showParts
        ? `${customCaptions.partPlural ?? "Parts"} and `
        : ""
    }${customCaptions.toolPlural} by Reason`,
    fetchData: async (params) => {
      return await getMissingPartsTools(params);
    },
    allowedChartTypes: ['vertical-bar', 'horizontal-bar', 'pie', 'tree-map'],
    defaultChartType: 'vertical-bar',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{
        label: 'Count'
      }]
    },
    series: [
      { 
        label: 'Count', 
        key: 'count', 
        colors: getAllColors(),
        showLegend: false
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
        allowedRanges: [
          'show-all',
          'today',
          'yesterday',
          'tomorrow',
          'this-week',
          'last-week',
          'last-month',
          'last-year',
          'last-7-days',
          'last-14-days',
          'last-30-days',
          'last-90-days',
          'custom'
        ]
      },
      department: { multiSelect: true },
      model: true
    },
    drilldown: {
      defaultChartType: 'vertical-bar',
      allowedChartTypes: ['vertical-bar', 'horizontal-bar', 'pie'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{
          label: `${customCaptions.part || 'Part'}/${customCaptions.tool || 'Tool'} Count`
        }]
      },
      series: [
        { 
          label: `${customCaptions.part || 'Part'}/${customCaptions.tool || 'Tool'} Count`, 
          key: 'count', 
          showLegend: false
        }
      ],
      breadcrumbLabel: `${customCaptions.part || 'Part'}/${customCaptions.tool || 'Tool'} Count`,
      getParams: (dataPoint) => {
        return {
          missingPartToolId: dataPoint.id
        };
      }
    }
  };

  return (
    <ReportPage 
      title={chartConfig.title}
      chartConfig={chartConfig}
    />
  );
};

export default MissingPartsToolsReport; 
